import type { Student } from 'src/dto'

import authApi from '@/api/auth.api'

import { makeAdapter } from './Adapter'
import type Controller from './Controller'

/***
 * @see authApi
 ***/
class AuthController implements Controller {
  adapter = makeAdapter({
    from(data) {
      return data
    },
    to(data: req.Login) {
      return {
        id: data.id.trim(),
        password: data.password.trim(),
      }
    },
  })

  async resetMyPassword(userId: string, password: req.ResetPassword) {
    await authApi.putPassword(userId, password)
  }

  async findPasswordFirstStep(params: req.FindPasswordFirstStep) {
    await authApi.postResetToken(params)
  }

  async findPasswordSecondStep(params: req.FindPasswordSecondStep) {
    await authApi.getCheckResetToken(params)
  }
  async findPasswordThirdStep(params: req.FindPasswordThirdStep) {
    await authApi.putCheckResetToken(params)
  }
  async resetStudentPassword(studentId: Student['id']) {
    await authApi.postPassword(studentId, {
      newPassword: '123456',
    })
  }
  async resetParentPassword(parentId: Student['loginId']) {
    await authApi.postPassword(parentId, {
      newPassword: '123456',
    })
  }
}

export const authController = new AuthController()
